import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import {
    updateSchemeBankAccountApproval, get_departments, AddBankAccount, getBankAccountById, update_account_balance_interest
} from '../../../helper/Api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import { Col, Container, Row } from 'react-bootstrap'
import AccountPreview from '../Model/AccountPreview';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
} from "@mui/material";
const AddChildAccount = () => {
    const { id,viewId} = useParams();
    const isReadOnly = viewId;
    const { authData } = useSelector((state) => state.authData);
    const [department, setDepartment] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [formData, setFormData] = useState({
        "id": "",
        "account_name": "",
        "bank_name": "",
        "branch_name": "",
        "ifsc_code": "",
        "ifsc_code_bank": "",
        "account_type": "",
        "account_no": "",
        "account_balance": "",
        "balance_date": "",
        "interest": "",
        "quarter": "",
        "interest_date": "",
        "email":"",
        "mobile":"",
        "l2_approval": "",
        "l3_approval": "",
        "l1_remark": "",
        "l2_remark": "",
        "l3_remark": "",
        "department_id": "",
        'added_by': authData.user.id,
        "approval_type": "joint"
    })

    const navigate = useNavigate();
    const previewHandler = (e) => {
        e.preventDefault();
        setShowPreview(true);
    };
    useEffect(() => {
        fetchDepartments();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let response;
            if (id) {
                response = await update_account_balance_interest(formData, id);
            } else {
                response = await AddBankAccount(formData);
            }
            if (response.data.status) {
                toast.success(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
                navigate('/childAccountList');
            } else {
                toast.error(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }
    const onApprove = async (status) => {
        formData.l2_approval = authData.user.user_type == 'l2' ? status : formData.l2_approval;
        formData.l3_approval = authData.user.user_type == 'l3' ? status : formData.l3_approval;
        let approvalData = {
            l2_approval: formData.l2_approval,
            l3_approval: formData.l3_approval,
            l2_remark: formData.l2_remark,
            l3_remark: formData.l3_remark
        }
        await updateSchemeBankAccountApproval(approvalData, formData.id);
    }
    const fetchDepartments = async () => {
        try {
            const departments = await get_departments({ department_level: '' });
            if (departments.data.status) {
                setDepartment(departments.data.result);
            }
        } catch (error) {
            console.log("departments");
        }
    }

    const fetchBankAccountById = async () => {
        try {
            const response = await getBankAccountById(id);
            if (response.data.status) {
                setFormData(response.data.result);
            } else {
                toast.error(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    useEffect(() => {
        if (id) {
            fetchBankAccountById();
        }
    }, [id]);

    return (
        <div>
            <AccountPreview showPreview={showPreview} setShowPreview={setShowPreview} formData={formData} handleSubmit={handleSubmit} department={department}></AccountPreview>
            <div className="p-3">
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Add Bank Account</h4>
                        <CustomBreadcrumbs linksArray={[{
                            href:'/childAccountList',
                            label: 'Bank Accounts'
                        }]} title="Add Bank Account"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button type="button" className="submit_button" onClick={() => setShowPreview(true)}>
                                {id ? 'Update Account' : 'Add Account'}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <Form>
                    <div className="col-md-12">
                        <div className="card p-3 mt-3">
                            <div className="row">
                                {/* <Form> */}
                                <Container>
                                    <Row>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Department *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    label="Department *"
                                                    id="department_id"
                                                    name='department_id'
                                                    required
                                                    value={formData.department_id || ""}
                                                    onChange={handleChange} 
                                                    readOnly={isReadOnly}
                                                >
                                                    {department.map((dept) => (
                                                        <MenuItem value={dept.id} key={dept.id}>
                                                            {dept.name} - {dept.code}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="account_name"
                                                label="Account Name" 
                                                variant="outlined" 
                                                type="text"
                                                name="account_name"
                                                value={formData.account_name || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="bank_name"
                                                label="Bank Name" 
                                                variant="outlined" 
                                                type="text"
                                                name="bank_name"
                                                value={formData.bank_name || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="branch_name"
                                                label="Branch Name" 
                                                variant="outlined" 
                                                type="text"
                                                name="branch_name"
                                                value={formData.branch_name || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Account Type *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    label="Account Type *"
                                                    id="account_type"
                                                    name='account_type'
                                                    required
                                                    value={formData.account_type || ""}
                                                    onChange={handleChange} 
                                                    readOnly={isReadOnly}
                                                >
                                                    <MenuItem value="saving" >Saving Account</MenuItem>
                                                    <MenuItem value="current" >Current Account</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="account_no"
                                                label="Account No" 
                                                variant="outlined" 
                                                type="number"
                                                name="account_no"
                                                value={formData.account_no || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="account_balance"
                                                label="Account Balance" 
                                                variant="outlined" 
                                                type="number"
                                                name="account_balance"
                                                value={formData.account_balance || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="ifsc_code"
                                                label="IFSC Code" 
                                                variant="outlined" 
                                                type="text"
                                                name="ifsc_code"
                                                value={formData.ifsc_code || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="ifsc_code_bank"
                                                label="IFSC Code - (Bank)" 
                                                variant="outlined" 
                                                type="text"
                                                name="ifsc_code_bank"
                                                value={formData.ifsc_code_bank || ""} 
                                                onChange={handleChange}
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="balance_date"
                                                    label="Closing Balance Date" 
                                                    variant="outlined" 
                                                    type="date"
                                                    name="balance_date"
                                                    value={formData.balance_date || ""} 
                                                    onChange={handleChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="interest"
                                                    label="Interest" 
                                                    variant="outlined" 
                                                    type="number"
                                                    name="interest"
                                                    value={formData.interest || ""} 
                                                    onChange={handleChange}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="interest_date"
                                                    label="Interest Date" 
                                                    variant="outlined" 
                                                    type="date"
                                                    name="interest_date"
                                                    value={formData.interest_date || ""} 
                                                    onChange={handleChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="quarter"
                                                    label="Quarter" 
                                                    variant="outlined" 
                                                    type="number"
                                                    name="quarter"
                                                    value={formData.quarter || ""} 
                                                    onChange={handleChange}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="email"
                                                    label="Email" 
                                                    variant="outlined" 
                                                    type="email"
                                                    name="email"
                                                    value={formData.email || ""} 
                                                    onChange={handleChange}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="mobile"
                                                    label="Mobile" 
                                                    variant="outlined" 
                                                    type="number"
                                                    name="mobile"
                                                    value={formData.mobile || ""} 
                                                    onChange={handleChange}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Approval Type *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    label="Approval Type *"
                                                    id="approval_type"
                                                    name='approval_type'
                                                    required
                                                    value={formData.approval_type || ""}
                                                    onChange={handleChange} 
                                                    readOnly={isReadOnly}
                                                >
                                                    <MenuItem value="joint" >Joint Approval</MenuItem>
                                                    <MenuItem value="single" >Single Approval</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        
                                    </Row>
                                    {
                                        authData.user.user_type == 'l1' ?
                                            <>
                                                <label>L1 Remark</label>
                                                <textarea className='form-control' onChange={handleChange} name="l1_remark" readOnly={isReadOnly}></textarea>
                                            </>
                                            : ''
                                    }
                                    <br />
                                    {
                                        authData.user.user_type == 'l2' && formData.l2_approval == null ?
                                            <>
                                                <label>L2 Remark</label>
                                                <textarea className='form-control' onChange={handleChange} name="l2_remark" readOnly={isReadOnly}></textarea>
                                                <button type="button" className="btn btn-danger w-30 mt-2" onClick={() => onApprove(0)}>Reject</button>
                                                <button type="button" className="btn btn-primary w-30 mt-2" style={{ marginLeft: '10px' }} onClick={() => onApprove(1)}>Approve</button>
                                            </>
                                            : ''
                                    }
                                    {
                                        authData.user.user_type == 'l3' && formData.l3_approval == null ?
                                            <>
                                                <label>L2 Remark</label>
                                                <textarea className='form-control' onChange={handleChange} name="l3_remark" readOnly={isReadOnly}></textarea>
                                                <button type="button" className="btn btn-danger w-30 mt-2" onClick={() => onApprove(0)}>Reject</button>
                                                <button type="button" className="btn btn-primary w-30 mt-2" style={{ marginLeft: '10px' }} onClick={() => onApprove(1)}>Approve</button>
                                            </>
                                            : ''
                                    }
                                </Container>
                                {/* </Form> */}
                            </div>
                        </div>
                    </div>
                    </Form>
                </div>
            </div>
        </div>
    )
};
export default AddChildAccount;